export default __webpack_public_path__ + "static/media/line-topbar-grey.5a3e3c03.svg";